import React, { Component } from 'react';

import { TagInput as TagInputEvergreen } from 'evergreen-ui';

import './style/TagInput.scss';

export default class TagInput extends Component {
	state = {
		valuesTargetInput: [''],
	};

	componentDidMount() {
		const { valueField } = this.props;
		this.setState({
			valuesTargetInput: valueField || [''],
		});
	}

	updateValues() {
		const {
			valuesTargetInput,
		} = this.state;

		const { nameField, onGetValueField } = this.props;

		const values = valuesTargetInput.filter((content) => {
			if (content !== '') {
				return content;
			}
			return this;
		});
		onGetValueField(nameField, values);
	}

	render() {
		const {
			question, required, messageErrorField, classContainer, meta,
		} = this.props;

		const { valuesTargetInput } = this.state;

		return (
			<div className={`component-question-data component-question-data col-12 form-group mb-4 p-0 ${classContainer}`}>
				<div>
					<p>
						{question}
						{required ? <span className="required">*Campos de preenchimento obrigatório.</span> : ''}
					</p>

					<TagInputEvergreen
						inputProps={{ placeholder: 'Digite e pressione enter para inserir sua tag!' }}
						values={valuesTargetInput}
						onChange={(values) => {
							this.setState({ valuesTargetInput: values }, this.updateValues);
						}}
						width="100%"
						tagProps={{
							color: 'red',
							isSolid: true,
						}}
					/>

					<p className="mt-1 description">{meta.description}</p>
				</div>

				<div className="help-block">{messageErrorField}</div>
			</div>
		);
	}
}
